import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class BigContainerOpening extends XYEffect {
	static key = "BigContainerOpening";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.AFTER_STATE_UPDATE);
	}
}
